import React from 'react';

import MainCategoryDetail from '../MainCategoryDetail';
import SubCategoryDetail from '../SubCategoryDetail';
import './CategoryDetailTab.scss';

const CategoryDetailTab = ({ category }) => {
  return (
    <div className="category-detail-content-wrap">
      <MainCategoryDetail category={category} />
      <hr className="category-detail-separate" />
      <SubCategoryDetail categoryStatus={category.status} />
    </div>
  );
};

export default CategoryDetailTab;
